import { render, staticRenderFns } from "./chart-bar-energy.vue?vue&type=template&id=4c4530cb"
import script from "./chart-bar-energy.vue?vue&type=script&lang=js"
export * from "./chart-bar-energy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports